import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl,
  InputLabel, MenuItem, Select, Tab, Tabs, Typography,
} from '@mui/material';
import { stargraveAdvancedWeapons } from '../../data/stargrave/advancedWeapons';
import { stargraveAdvancedTechnology } from '../../data/stargrave/advancedTechnology';
import { stargraveAlienArtefacts } from '../../data/stargrave/alienArtefacts';

interface StargraveSecretModalProps {
  open: boolean;
  onClose: () => void;
  onRedeem: (reward: { kind: 'advancedWeapon' | 'advancedTechnology' | 'alienArtefact'; itemId: string }) => void;
}

interface SecretRewardItem {
  id: string;
  name: string;
  summary: string;
}

const categories: Array<{ kind: 'advancedWeapon' | 'advancedTechnology' | 'alienArtefact'; label: string; items: SecretRewardItem[] }> = [
  { kind: 'advancedWeapon', label: 'Advanced Weapon', items: stargraveAdvancedWeapons },
  { kind: 'advancedTechnology', label: 'Advanced Technology', items: stargraveAdvancedTechnology },
  { kind: 'alienArtefact', label: 'Alien Artefact', items: stargraveAlienArtefacts },
];

export const StargraveSecretModal: React.FC<StargraveSecretModalProps> = ({ open, onClose, onRedeem }) => {
  const [categoryIndex, setCategoryIndex] = React.useState(0);
  const [itemId, setItemId] = React.useState('');
  const category = categories[categoryIndex];
  const selected = category.items.find((item) => item.id === itemId);
  const close = () => { setCategoryIndex(0); setItemId(''); onClose(); };

  return <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
    <DialogTitle>Redeem Secret</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
      <Typography variant="body2" color="text.secondary">
        Redeem after recovering the central loot token. The Secret is consumed.
      </Typography>
      <Tabs value={categoryIndex} onChange={(_, value) => { setCategoryIndex(value); setItemId(''); }} variant="scrollable" scrollButtons="auto">
        {categories.map((item) => <Tab key={item.kind} label={item.label} />)}
      </Tabs>
      <FormControl fullWidth>
        <InputLabel id="secret-reward-item">Reward</InputLabel>
        <Select labelId="secret-reward-item" label="Reward" value={itemId} onChange={(event) => setItemId(event.target.value)}>
          {category.items.map((item) => <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>)}
        </Select>
      </FormControl>
      {selected && <React.Fragment>
        <Typography variant="h6">{selected.name}</Typography>
        <Typography variant="body2">{selected.summary}</Typography>
      </React.Fragment>}
    </DialogContent>
    <DialogActions>
      <Button onClick={close}>Cancel</Button>
      <Button variant="contained" disabled={!selected} onClick={() => { onRedeem({ kind: category.kind, itemId }); close(); }}>Redeem</Button>
    </DialogActions>
  </Dialog>;
};
